// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export type AppRouteKey =
  | "login"
  | "onboarding"
  | "contacts"
  | "tasks"
  | "journeys"
  | "communications"
  | "property"
  | "vendors"
  | "workOrders"
  | "workloadForecasts"
  | "delegations"
  | "prospecting"
  | "relationships"
  | "insights"
  | "documents"
  | "settings";

export interface AppRoute {
  key: AppRouteKey;
  path: string;
  title: string;
  requiresAuth: boolean;
}

export const appRoutes: AppRoute[] = [
  { key: "login", path: "/", title: "Sign in", requiresAuth: false },
  {
    key: "onboarding",
    path: "/onboarding",
    title: "Onboarding",
    requiresAuth: true,
  },
  {
    key: "insights",
    path: "/insights",
    title: "Daily Brief",
    requiresAuth: true,
  },
  {
    key: "journeys",
    path: "/journeys",
    title: "Client and Property Journeys",
    requiresAuth: true,
  },
  {
    key: "prospecting",
    path: "/prospecting",
    title: "Prospecting",
    requiresAuth: true,
  },
  {
    key: "relationships",
    path: "/relationships",
    title: "Relationships",
    requiresAuth: true,
  },
  {
    key: "communications",
    path: "/communications",
    title: "Communications",
    requiresAuth: true,
  },
  {
    key: "contacts",
    path: "/contacts",
    title: "Contacts and Relationships",
    requiresAuth: true,
  },
  {
    key: "tasks",
    path: "/tasks",
    title: "Tasks and Scheduling",
    requiresAuth: true,
  },
  {
    key: "property",
    path: "/property",
    title: "Property Operations",
    requiresAuth: true,
  },
  {
    key: "vendors",
    path: "/vendors",
    title: "Vendors",
    requiresAuth: true,
  },
  {
    key: "workOrders",
    path: "/work-orders",
    title: "Work Orders",
    requiresAuth: true,
  },
  {
    key: "workloadForecasts",
    path: "/workload-forecasts",
    title: "Workload Forecasts",
    requiresAuth: true,
  },
  {
    key: "delegations",
    path: "/delegations",
    title: "Delegations",
    requiresAuth: true,
  },
  {
    key: "documents",
    path: "/documents",
    title: "Documents",
    requiresAuth: true,
  },
  {
    key: "settings",
    path: "/settings",
    title: "Settings",
    requiresAuth: true,
  },
];

export function getRouteByPath(pathname: string): AppRoute {
  const normalizedPath = pathname.toLowerCase();
  const fallbackRoute = appRoutes[0]!;
  return (
    appRoutes.find((route) => route.path === normalizedPath) ?? fallbackRoute
  );
}
